export enum InputTypes {
  Text = 'Text',
  Number = 'Number',
  Date = 'Date'
}
